import {of, Subject} from "rxjs";

let services = null;
let servicesToBe = new Subject();

export function setServices(value) {
    services = value;
    servicesToBe.next(services);
}

export function getServices() {
    if (services) {
        return of(services);
    } else {
        return servicesToBe;
    }
}

let guidedTours = null;
let guidedToursToBe = new Subject();

export function setGuidedTours(value) {
    guidedTours = value;
    guidedToursToBe.next(guidedTours);
}

export function getGuidedTours() {
    if (guidedTours) {
        return of(guidedTours);
    } else {
        return guidedToursToBe;
    }
}

let publications = null;
let publicationsToBe = new Subject();

export function setPublications(value) {
    publications = value;
    publicationsToBe.next(publications);
}

export function getPublications() {
    if (publications) {
        return of(publications);
    } else {
        return publicationsToBe;
    }
}

let articles = null;
let articlesToBe = new Subject();

export function setArticles(value) {
    articles = value;
    articlesToBe.next(articles);
}

export function getArticles() {
    if (articles) {
        return of(articles);
    } else {
        return articlesToBe;
    }
}
